<template>
  <el-header class="header">
    <span id="home"><router-link to="/">Home</router-link></span>
    <span v-show="loginShow" id="username">{{username}}</span>
    <el-dropdown v-show="loginShow" id="dropdown" @command="handleCommand">
      <span class="el-dropdown-link">
        <img id="avatar" v-show="loginShow" src="../media/BaseAvatar.png">
      </span>

      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="preferences">Preferences</el-dropdown-item>
        <el-dropdown-item command="logout">LogOut</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-header>
</template>

<script>
  export default {
    name: 'Header',
    data () {
      return {
        loginShow: false,
        username: this.$cookie.get('user')
      }
    },
    watch:{
      $route (to, from){
        if(to.path === "/")
          this.loginShow = false;
        else
          this.loginShow = true;

        this.username = this.$cookie.get('user');
        if(this.username !== null) {
          this.username = this.username.replace(/^\w/, function (chr) {
            return chr.toUpperCase();
          });
        }
      },
    },
    methods: {
      handleCommand: function (command) {
        let app = this;
        switch(command) {
          case "logout": {
            if(app.$cookie.get('user') !== null){
              app.$cookie.delete('user')
              app.$router.push('/')
            }
            let metaThemeColor = document.querySelector("meta[name=theme-color]");
            let bodyStyles = document.body.style;
            bodyStyles.setProperty('--primary-color', '#C5C5C5');
            bodyStyles.setProperty('--secondary-color', '#6C7478');
            bodyStyles.setProperty('--tertiary-color', '#FFFFFF');

            // Set the meta theme color to reflect the change (for mobile)
            metaThemeColor.setAttribute("content", "#6C7478");
            break;
          }
          case "preferences": {
            app.$router.push('/preferences')
            break;
          }
        }
      }
    }
  }
</script>

<style scoped>
  #home{
    margin-right: auto;
  }
  #home a{
    font-weight: bold;
  }
  #avatar{
    object-fit: cover;
    border-radius: 50%;
    vertical-align: middle;
  }
  .el-icon-caret-bottom{
    color: #ffffff;
  }
  #dropdown{
    width: 70px;
    height:auto;
    cursor: pointer;
  }
  .el-header{
    display: flex;
    align-items:center;
    text-align: left!important;
    justify-content: flex-end;
  }
  span {
    color: #FFFFFF;
    padding-right: 2%;
  }
  img{
    width: 50px;
    height: 50px;
  }
</style>




// WEBPACK FOOTER //
// src/components/Header.vue